import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

/**
 * Updates the authenticated user's profile via PUT /v1/user/profile.
 * Used for KYC onboarding with verification_token + birthDate.
 */
export const updateUserProfileService = async payload => {
  const transformedPayload = {
    ...payload,
    firstName: payload.firstname ?? payload.firstName,
    lastName: payload.lastname ?? payload.lastName,
    birthDate: payload.birthDate ?? payload.birthdate ?? payload.birth_date,
  };

  delete transformedPayload.firstname;
  delete transformedPayload.lastname;
  delete transformedPayload.birthdate;
  delete transformedPayload.birth_date;

  const cleanedPayload = Object.fromEntries(
    Object.entries(transformedPayload).filter(([, value]) => value !== undefined)
  );

  return privateRequest.put(ConfEnv.API_URL.URL_USER_PROFILE, cleanedPayload);
};
